import { useFacilityStore } from '../stores/facility-store';
import { useTenantTimezone } from '../contexts/tenant-timezone-context';
import { resolveTimezone } from '../lib/timezone';

/**
 * Returns the IANA timezone string for the current facility context.
 *
 * Resolution (first non-null wins): facility timezone → facility state →
 * tenant timezone → 'Australia/Sydney' fallback. When a facility is selected
 * the facility timezone/state wins; the tenant timezone only takes effect on
 * the tenant-wide view ("All Facilities", currentFacility === null).
 *
 * Signature is intentionally sync `(): string` — the tenant timezone is read
 * from the shell-seeded TenantTimezoneContext, so no async round-trip is
 * introduced and the ~257 existing call sites remain unchanged. Safe to call
 * before the facility store or shell context loads — returns the default.
 */
export function useTimezone(): string {
  const facility = useFacilityStore((s) => s.currentFacility);
  const tenantTimezone = useTenantTimezone();
  return resolveTimezone({
    facilityTimezone: facility?.timezone ?? null,
    facilityState: facility?.state ?? null,
    tenantTimezone,
  });
}
